function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M13.8444 9.4229C13.6381 9.4229 13.4708 9.59014 13.4708 9.79648V13.1134C13.4701 13.7322 12.9688 14.2336 12.3501 14.2342H1.86789C1.24915 14.2336 0.747885 13.7322 0.747155 13.1134V3.37839C0.747885 2.75979 1.24915 2.25838 1.86789 2.25765H5.18485C5.39119 2.25765 5.55843 2.09042 5.55843 1.88408C5.55843 1.67788 5.39119 1.5105 5.18485 1.5105H1.86789C0.836756 1.51167 0.00116743 2.34725 0 3.37839V13.1136C0.00116743 14.1447 0.836756 14.9803 1.86789 14.9815H12.3501C13.3812 14.9803 14.2168 14.1447 14.218 13.1136V9.79648C14.218 9.59014 14.0508 9.4229 13.8444 9.4229Z",
  fill: "#242424"
}), React.createElement("path", {
  d: "M14.0698 0.549255C13.4133 -0.107279 12.3489 -0.107279 11.6923 0.549255L5.02746 7.21411C4.98178 7.25979 4.9488 7.31641 4.93158 7.37858L4.05514 10.5428C4.01909 10.6725 4.05572 10.8114 4.15087 10.9067C4.24616 11.0018 4.38508 11.0385 4.51481 11.0026L7.67899 10.126C7.74115 10.1088 7.79777 10.0758 7.84345 10.0301L14.5082 3.3651C15.1637 2.70813 15.1637 1.6446 14.5082 0.987625L14.0698 0.549255ZM5.84145 7.45694L11.2961 2.00212L13.0553 3.76129L7.60048 9.21611L5.84145 7.45694ZM5.49005 8.16207L6.89549 9.56765L4.95143 10.1063L5.49005 8.16207ZM13.9799 2.83683L13.5837 3.23303L11.8244 1.47371L12.2207 1.07752C12.5854 0.712841 13.1767 0.712841 13.5414 1.07752L13.9799 1.51589C14.344 1.881 14.344 2.47187 13.9799 2.83683Z",
  fill: "#242424"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})));

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editIcon.a8c99f57.svg";
export { ForwardRef as ReactComponent };